<template>
  <stu-tutorial @seeDetails="lookOverDetail($event)"
                @back="goBack"></stu-tutorial>
</template>

<script>
  import {routerJump} from "@/assets/js/yioksRouter";
  export default {
    name: "student-tutorial",
    beforeRouteEnter (to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      next((vm)=>{
        if(to.query.home) {
          vm.isToHome = true;
        }
      });
    },
    data() {
      return {
        isToHome: false,
      };
    },
    components: {
      /* query: user_id && c_id
       * params: userId && classId
       */
      'stu-tutorial': () => import('@/components/Tutorial/stu-tutorial')
    },
    methods: {
      goBack() {
        if(this.isToHome) {
          const path = routerJump();
          this.$router.replace(path);
        }else{
          this.$router.go(-1);
        }
      },
      lookOverDetail(id) {
        this.$router.push({
          path: "tutorial_detail",
          query: {
            id: id,
          }
        });
      },
    },
  }
</script>